import React from 'react';
import { useState } from 'react';
import '../assets/css/ShareButtons.css';

const ShareButtons = () => {
  // Get the current URL of the page (assuming this is a blog page)
  const currentUrl = window.location.href;

  const [copied, setCopied] = useState(false);

  // Handle Facebook share
  const handleFacebookShare = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
    window.open(facebookUrl, '_blank', 'width=600, height=400');
  };

  // Handle Twitter share
  const handleTwitterShare = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=Check out this blog on Easy Data Structures!`;
    window.open(twitterUrl, '_blank', 'width=600, height=400');
  };

  // Handle LinkedIn share
  const handleLinkedInShare = () => {
    const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}&title=Check out this blog on Easy Data Structures!`;
    window.open(linkedinUrl, '_blank', 'width=600, height=400');
  };

  // Handle Copy Link to clipboard
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);

      // Optional: reset button text after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link', err);
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
        <h2>Share on Social Media</h2>

        <div className="share-buttons">
        <button onClick={handleFacebookShare} className="share-button" title="Share on Facebook">
            <i class="bi bi-facebook"></i> Share on Facebook
        </button>

        <button onClick={handleTwitterShare} className="share-button" title="Share on Twitter">
            <i class="bi bi-twitter-x"></i> Share on Twitter
        </button>

        <button onClick={handleLinkedInShare} className="share-button" title="Share on LinkedIn">
            <i class="bi bi-linkedin"></i> Share on LinkedIn
        </button>

        <button onClick={handleCopyLink} className="share-button">
          <i className="bi bi-link-45deg"></i> {copied ? 'Copied' : 'Copy Link'}
        </button>
        </div>
    </div>

  );
};

export default ShareButtons;